import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';
import { getCountryOverallTrend, getOverallTrends } from 'Utils/calcOverallTrend';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { roundDownSmart } from 'Utils/roundDown';

const atlas = new AtlasMetadataClient();

const TopDailyHeadline = (props) => {
  const { globalStatistics, globalCounts } = props;

  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext).template.dailyCounts;

  const movers = [];
  Object.keys(globalStatistics.latestWeeklyAvgs.cases).forEach(country => {
    const { cases: casesTrend } = getCountryOverallTrend(globalStatistics, country);
    const latestAvg = globalStatistics.latestWeeklyAvgs.cases[country][3];
    const earlierAvg = globalStatistics.latestWeeklyAvgs.cases[country][0];
    if (!casesTrend.increasing || latestAvg < 1000) return;

    movers.push({
      country,
      name: atlas.getCountry(country).translations[locale],
      avgChange: (latestAvg - earlierAvg) / earlierAvg,
    });
  });

  movers.sort((a, b) => a.avgChange - b.avgChange);

  const trends = getOverallTrends(globalStatistics);
  const casesRising = Object.keys(trends)
    .filter(country => trends[country].cases.increasing).length;

  const cases = roundDownSmart(globalCounts.cases.reduce((a, d) => a + d.count, 0));
  const deaths = roundDownSmart(globalCounts.deaths.reduce((a, d) => a + d.count, 0));

  return (
    <div className={classnames(component)}>
      <div className='section-spacer' />
      <div>
        <h2>{content.title}</h2>
        <SmartText
          source={content.intro}
          context={{
            rising: (
              <span className='highlight' key='rising'>
                {casesRising.toLocaleString(locale)}
              </span>
            ),
            deaths: (
              <span className='highlight' key='deaths'>
                {deaths.toLocaleString(locale)}
              </span>
            ),
            cases: (
              <span className='highlight' key='cases'>
                {cases.toLocaleString(locale)}
              </span>
            ),
          }}
          wrap
        />
      </div>
    </div>
  );
};

export default TopDailyHeadline;
